import React from "react";
import { FaPhone } from "react-icons/fa";

import images from "../../constants/images";
import "./Footer.css";

const DOORDASH_URL =
  "https://www.doordash.com/store/pho-ha-long-san-antonio-41685551/103535348/?aw=hEV_jbHuzoPHt7HK";

const Footer = () => {
  const address = "6424 Northwest Loop 410 #104, San Antonio, TX 78238";
  const encodedAddress = encodeURIComponent(address);
  const mapUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

  return (
    <footer className="app__footer">
      <div className="app__footer-content">
        {/* Column 1: Brand */}
        <div className="app__footer-column">
          <div className="app__footer-brand">
            <img src={images.phohalong} alt="Pho Ha Long logo" />
            <span className="app__footer-brand-name">Pho Ha Long</span>
          </div>
          <p className="app__footer-tagline">
            Authentic Vietnamese flavors in the heart of San Antonio.
            Traditional recipes, fresh ingredients, served with care.
          </p>
        </div>

        {/* Column 2: Contact */}
        <div className="app__footer-column">
          <h3>Contact</h3>
          <p>
            <a href={mapUrl} target="_blank" rel="noopener noreferrer">
              {address}
            </a>
          </p>
          <a href="tel:+12103547547" className="app__footer-phone">
            <FaPhone />
            <span>(210) 354-7547</span>
          </a>
          <a
            href={DOORDASH_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="app__footer-doordash"
          >
            Order on DoorDash →
          </a>
        </div>

        {/* Column 3: Hours */}
        <div className="app__footer-column">
          <h3>Hours</h3>
          <div className="app__footer-hours-row">
            <span>Tuesday – Sunday</span>
            <span>11 AM – 8 PM</span>
          </div>
          <div className="app__footer-hours-row">
            <span>Monday</span>
            <span>Closed</span>
          </div>
        </div>
      </div>

      <hr className="app__footer-divider" />

      <div className="app__footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} Pho Ha Long. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
